import React, { useState } from 'react';
import moment from 'moment';
import CommentBox from '../../admin/parcel/components/comment';
import EditIcon from '@material-ui/icons/Edit';
import Check from '@material-ui/icons/Check';
import Cross from '@material-ui/icons/Clear';
import Call from '@material-ui/icons/Call';
import API from '../../../create/api';

export default function MobileTableRow({ row, index, refreshData }: any) {
  const [editCODBool, setEditCODBool] = useState(false);
  const [editStatusBool, setEditStatusBool] = useState(false);

  const [editCOD, setEditCOD] = useState(row?.merchant_COD);
  const [editStatus, setEditStatus] = useState(row?.status);

  function updateCOD() {
    return API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, row?.id, {
      collected_amount: editCOD,
      return_product_price: (row.merchant_COD ?? 0) - editCOD,
    }).finally(() => {
      refreshData();
      setEditCODBool(false);
    });
  }

  function CODDom(collectedAmount: number, merchantCOD: number) {
    return (
      <React.Fragment>
        {collectedAmount > 0 && collectedAmount !== merchantCOD ? (
          <span>
            <span className="line-through mr-1">{merchantCOD}</span>
            <span>{collectedAmount}</span>
          </span>
        ) : (
          row?.merchant_COD ?? 'N/A'
        )}
      </React.Fragment>
    );
  }

  function StatusDom() {
    return <React.Fragment>{statusMapper(row?.status)}</React.Fragment>;
  }

  function statusMapper(status: string) {
    switch (status) {
      case 'DELIVERED_BY_RIDER':
        return 'Delivered';
      case 'RETURNED_BY_RIDER':
        return 'Returned';
      case 'ON_DELIVERY':
        return 'On Delivery';
      case 'PARTIALLY_DELIVERED_BY_RIDER':
        return 'Partial Delivered';
      default:
        return status;
    }
  }

  return (
    <div className="border-2 shadow-blue-100 shadow-lg rounded-md p-3 mb-3 bg-gray-300 grid grid-cols-3 gap-4">
      <div>
        <span className="text-gray-500">
          #{index + 1}{' '}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="15"
            height="15"
            fill="currentColor"
            className="inline-block"
          >
            <path d="M19 3h-1V2a1 1 0 0 0-2 0v1H8V2a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9h16v9zm0-11H4V6a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V5h6v1a1 1 0 0 0 2 0V5h2a1 1 0 0 1 1 1v1z" />
          </svg>
          {row.booking_date}
        </span>
      </div>
      <div>
        <span className="text-gray-500">APN: </span>
        {row?.id}
      </div>
      <div>
        <span className="text-gray-500">Invoice:</span> {row?.memoNo ?? 'N/A'}
      </div>
      <div>
        <span className="text-gray-500">Company: </span>
        {row?.company.name ?? 'N/A'}
      </div>
      <div>
        <span className="text-gray-500">Customer: </span>
        {row?.customerName ?? 'N/A'}
      </div>
      <div className="col-span-3 grid grid-cols-2 ">
        <div>
          <div>
            <span className="text-gray-500">Status: </span>
          </div>
          {StatusDom()}
        </div>
        <div className="">
          <div>
            <span className="text-gray-500">Merchant COD: </span>
          </div>
          <div>{CODDom(row?.collected_amount, row?.merchant_COD)}</div>
        </div>
      </div>
    </div>
  );
}
